import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fuelTankFilled"
const FuelTankFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.75 1.5C13.578 1.5 14.25 2.172 14.25 3V13.5H15.375C16.618 13.5 17.625 14.507 17.625 15.75V19.688C17.625 20.412 18.213 21 18.938 21 19.662 21 20.25 20.412 20.25 19.688V11.747C19.909 11.908 19.528 12 19.125 12 17.675 12 16.5 10.825 16.5 9.375 16.5 8.136 17.358 7.099 18.512 6.823L15.97 4.28 17.03 3.22 20.651 6.84C21.184 7.375 21.54 8.052 21.681 8.782Q21.748 9.068 21.75 9.375L21.748 9.429 21.75 9.493V19.688C21.75 21.24 20.49 22.5 18.938 22.5 17.384 22.5 16.125 21.24 16.125 19.688V15.75C16.125 15.336 15.789 15 15.375 15H14.25V21C14.25 21.828 13.578 22.5 12.75 22.5H3.75C2.922 22.5 2.25 21.828 2.25 21V3C2.25 2.172 2.922 1.5 3.75 1.5zM8.844 9.157C8.564 8.714 7.936 8.714 7.656 9.157 6.989 10.217 6 11.926 6 12.75 6 13.993 7.007 15 8.25 15S10.5 13.993 10.5 12.75C10.5 11.926 9.51 10.216 8.844 9.157M19.125 8.25C18.504 8.25 18 8.754 18 9.375S18.504 10.5 19.125 10.5C19.727 10.5 20.216 10.027 20.246 9.433Q20.242 9.256 20.21 9.085C20.082 8.605 19.646 8.25 19.125 8.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FuelTankFilledIcon
